import type { ActorDto } from '@newo/api-client';
import type { RichTranslateFn, TranslateFn } from '@newo/localization';

export enum CreatorRenderMode {
	Closed = 'closed',
	Page = 'page',
	Overlay = 'overlay',
	Mini = 'mini'
}

export interface CreatorRemoteProps {
	actor?: ActorDto;
	renderMode: CreatorRenderMode;
	isMiniCreatorFeatureEnabled: boolean;
	enableMiniMode: () => void;
	expandToPage: () => void;
	handleCloseCreator: () => void;
	partner_idn: string | null;
	member_idn: string | null;
	localization: {
		translate: TranslateFn;
		rich: RichTranslateFn;
		language: string;
		onChangeLanguage: (language: string | null) => void;
	};
	handleAgentCreationSuccess?: () => void;
}
